module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table2"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-2：资质情况表 ———— 音像制品出版许可证")]) : _c('span', [_vm._v("表 1-2：资质情况表 ———— 电子出版物出版许可证")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版许可证号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.xkzNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "xkzNum", $$v)
      },
      expression: "params.xkzNum"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.orgName),
      callback: function($$v) {
        _vm.$set(_vm.params, "orgName", $$v)
      },
      expression: "params.orgName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.orgAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "orgAddr", $$v)
      },
      expression: "params.orgAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版者码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.cbzMa),
      callback: function($$v) {
        _vm.$set(_vm.params, "cbzMa", $$v)
      },
      expression: "params.cbzMa"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.fddbr),
      callback: function($$v) {
        _vm.$set(_vm.params, "fddbr", $$v)
      },
      expression: "params.fddbr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("有效日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yxStartDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(1)
      }
    },
    model: {
      value: (_vm.params.yxStartDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "yxStartDate", $$v)
      },
      expression: "params.yxStartDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midSpan"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "yxEndDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(2)
      }
    },
    model: {
      value: (_vm.params.yxEndDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "yxEndDate", $$v)
      },
      expression: "params.yxEndDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.businessScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessScope", $$v)
      },
      expression: "params.businessScope"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他主要业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherScope", $$v)
      },
      expression: "params.otherScope"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位设立获批时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "approvalTime", $$v)
      },
      expression: "params.approvalTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("发文文件：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [(_vm.params.publishFileId) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.filesDown(_vm.params.publishFileId)
      }
    }
  }, [_vm._v("\n                下载\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.params.publishFileId) ? _c('span', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "size": "mini",
      "type": "danger"
    }
  }, [_vm._v(" 未上传 ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("需要说明的其他情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherSituation", $$v)
      },
      expression: "params.otherSituation"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("出版许可证：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId1,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId1'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证正本")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId2,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId2'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本盖章页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId3,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId3'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本单位信息页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId4,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId4'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本年度核验记录页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId5,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId5'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本变更记录页")])], 1)])])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版许可证号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.xkzNum !== _vm.params.xkzNum ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.xkzNum),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "xkzNum", $$v)
      },
      expression: "historyJsonParams.xkzNum"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.orgName !== _vm.params.orgName ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.orgName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "orgName", $$v)
      },
      expression: "historyJsonParams.orgName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.orgAddr !== _vm.params.orgAddr ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.orgAddr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "orgAddr", $$v)
      },
      expression: "historyJsonParams.orgAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版者码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.cbzMa !== _vm.params.cbzMa ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.cbzMa),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "cbzMa", $$v)
      },
      expression: "historyJsonParams.cbzMa"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.fddbr !== _vm.params.fddbr ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.fddbr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "fddbr", $$v)
      },
      expression: "historyJsonParams.fddbr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("有效日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    class: _vm.historyJsonParams.areaDate !== _vm.params.areaDate ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "type": "daterange",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.historyJsonParams.areaDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "areaDate", $$v)
      },
      expression: "historyJsonParams.areaDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.businessScope !== _vm.params.businessScope ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 8,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.businessScope),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "businessScope", $$v)
      },
      expression: "historyJsonParams.businessScope"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他主要业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.otherScope !== _vm.params.otherScope ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.otherScope),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "otherScope", $$v)
      },
      expression: "historyJsonParams.otherScope"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位设立获批时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    class: _vm.historyJsonParams.approvalTime !== _vm.params.approvalTime ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.historyJsonParams.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "approvalTime", $$v)
      },
      expression: "historyJsonParams.approvalTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("需要说明的其他情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.otherSituation !== _vm.params.otherSituation ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "otherSituation", $$v)
      },
      expression: "historyJsonParams.otherSituation"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("出版许可证：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId1,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId1'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证正本")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId2,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId2'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本盖章页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId3,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId3'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本单位信息页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId4,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId4'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本年度核验记录页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId5,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId5'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本变更记录页")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("主办及主管单位信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostName", $$v)
      },
      expression: "params.hostName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.hostType),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostType", $$v)
      },
      expression: "params.hostType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("中央")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("地方")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostCategory",
      "width": "200px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "width": "200px",
      "size": "small",
      "placeholder": "请选择主办单位性质"
    },
    model: {
      value: (_vm.params.hostCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostCategory", $$v)
      },
      expression: "params.hostCategory"
    }
  }, _vm._l((_vm.cats), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.params.hostCategory == '5') ? _c('el-form-item', {
    attrs: {
      "prop": "hostOtherCategory",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "需要填写具体主办单位性质"
    },
    model: {
      value: (_vm.params.hostOtherCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostOtherCategory", $$v)
      },
      expression: "params.hostOtherCategory"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostAddr", $$v)
      },
      expression: "params.hostAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostPostalcode", $$v)
      },
      expression: "params.hostPostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostLinkman", $$v)
      },
      expression: "params.hostLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostTel", $$v)
      },
      expression: "params.hostTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostPhone", $$v)
      },
      expression: "params.hostPhone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeName", $$v)
      },
      expression: "params.chargeName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.chargeType),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeType", $$v)
      },
      expression: "params.chargeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("中央")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("地方")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeCategory",
      "width": "200px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "width": "200px",
      "size": "small",
      "placeholder": "请选择主管单位性质"
    },
    model: {
      value: (_vm.params.chargeCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeCategory", $$v)
      },
      expression: "params.chargeCategory"
    }
  }, _vm._l((_vm.cats), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.params.chargeCategory == '5') ? _c('el-form-item', {
    attrs: {
      "prop": "chargeOtherCategory",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "需要填写具体主管单位性质"
    },
    model: {
      value: (_vm.params.chargeOtherCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeOtherCategory", $$v)
      },
      expression: "params.chargeOtherCategory"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeAddr", $$v)
      },
      expression: "params.chargeAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargePostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargePostalcode", $$v)
      },
      expression: "params.chargePostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeLinkman", $$v)
      },
      expression: "params.chargeLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeTel", $$v)
      },
      expression: "params.chargeTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargePhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargePhone", $$v)
      },
      expression: "params.chargePhone"
    }
  })], 1)])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostName !== _vm.params.hostName ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostName", $$v)
      },
      expression: "historyJsonParams.hostName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostAddr !== _vm.params.hostAddr ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostAddr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostAddr", $$v)
      },
      expression: "historyJsonParams.hostAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostPostalcode !== _vm.params.hostPostalcode ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostPostalcode", $$v)
      },
      expression: "historyJsonParams.hostPostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostLinkman !== _vm.params.hostLinkman ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostLinkman),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostLinkman", $$v)
      },
      expression: "historyJsonParams.hostLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostTel !== _vm.params.hostTel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostTel),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostTel", $$v)
      },
      expression: "historyJsonParams.hostTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostPhone !== _vm.params.hostPhone ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostPhone),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostPhone", $$v)
      },
      expression: "historyJsonParams.hostPhone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargeName !== _vm.params.chargeName ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargeName", $$v)
      },
      expression: "historyJsonParams.chargeName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargeAddr !== _vm.params.chargeAddr ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargeAddr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargeAddr", $$v)
      },
      expression: "historyJsonParams.chargeAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargePostalcode !== _vm.params.chargePostalcode ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargePostalcode),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargePostalcode", $$v)
      },
      expression: "historyJsonParams.chargePostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargeLinkman !== _vm.params.chargeLinkman ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargeLinkman),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargeLinkman", $$v)
      },
      expression: "historyJsonParams.chargeLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargeTel !== _vm.params.chargeTel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargeTel),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargeTel", $$v)
      },
      expression: "historyJsonParams.chargeTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargePhone !== _vm.params.chargePhone ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargePhone),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargePhone", $$v)
      },
      expression: "historyJsonParams.chargePhone"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.params.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版许可证信息（请按照出版许可证上的信息填写）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-669faee6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table2.vue
// module id = 1758
// module chunks = 1